import algoliasearch from 'algoliasearch';

const appId = "2YJECNF7H4";
const apiKey = "2bd7ab73a3087f37d5dbb27ed66dd1f9";

export const searchClient = algoliasearch(appId, apiKey);
